module.exports = __webpack_public_path__ + "img/marker-point-azul-claro.5c1a9386.png";